import { LinearFilter, UVMapping } from "three";
/**
 * A Image Tile of Panorama Quadtree-Image
 * @class PanoTile
 * @param tMesh
 * @param tGeometry
 * @param camerIndex
 * @param quadcode
 * @param extent
 * @param baseurl
 * @constructor
 */
export class MultiPerspectiveTile {
    constructor(tMesh, tGeometry, cameraIndex, quadCode, extent, tileReady, parentquadtree) {
        this.tMesh = tMesh;
        this.tGeometry = tGeometry;
        this.cameraIndex = cameraIndex;
        this.quadCode = quadCode;
        this.extent = extent;
        this.tileReady = false;
        this.initialized = false;
        this.parent = parentquadtree;
        this.tMesh.userData = this;
    }
    loadTexture(url) {
        this.requestedurl = url;
        this.initialized = true;
        this.parent.currentTraversalState.scene.engine.requestTexture(url, UVMapping, (texture) => {
            this._tileLoadSuccess(texture);
        }, () => {
            this.tileLoadFailed();
        }, false);
    }
    _tileLoadSuccess(texture) {
        // this was a callback from an old reqeust!
        if (texture.name.indexOf(this.requestedurl) < 0)
            return;
        texture.minFilter = LinearFilter;
        this.tMesh.material.uniforms["uTexture"] = { value: texture };
        this.tMesh.material.uniforms["uGamma"] = {
            value: this.parent.currentTraversalState.gamma + this.parent.gamma_addconst,
        };
        this.tMesh.material.uniforms["fCalloteId"] = { value: this.cameraIndex };
        this.tMesh.material.uniforms["fLod"] = { value: this.quadCode.length };
        this.tMesh.material.needsUpdate = true;
        this.tileReady = true;
    }
    tileLoadFailed() {
        console.log("ERROR MultiPerspectiveTILE");
    }
    destroy() {
        try {
            this.tMesh.material.uniforms.uTexture.value?.dispose();
            this.tMesh.material.dispose();
            this.tGeometry.dispose();
        }
        catch (e) {
            console.error("ERROR destroy tile " + this.quadCode, e);
        }
    }
}
//# sourceMappingURL=multiperspectivetile.js.map